module.exports = __webpack_public_path__ + "media/assets/MenuDotted-e326fc448e59e30208572fcc31fc8247.svg";